// extracted by mini-css-extract-plugin
export var loaderContainer = "{prismicPage-url}-module--loader-container--88e50";
export var spinner = "{prismicPage-url}-module--spinner--75cff";